import React from "react"
import { connect, ConnectedProps } from "react-redux"
import { LogoApp } from "./SideNav.styles"
// import IMGlogo from "src/assets/images/logo.png"
import { HAuth } from "src/core/helpers"
import { getHomepageUrl } from "src/core/helpers/auth"
import { HCF } from "@macashipo/mlib"
// import { HLog } from "src/core/helpers"
const mapStateToProps = state => ({
  closeSideNav: state.app.closeSideNav,
})

const mapDispatchToProps = {}

const connector = connect(mapStateToProps, mapDispatchToProps)

interface Props extends ConnectedProps<typeof connector> {}

function SideNavHeader(props: Props) {
  // const { closeSideNav } = props
  const getLogoApp = () => {
    const useLogoServer = HCF.getCF("useLogoServer")
    const defaultLogo = HCF.getCF("pathMainLogo")
    const userLogoApp = HAuth.getUserLogoApp()
    if (useLogoServer) {
      if (userLogoApp) {
        return userLogoApp
      }
    }
    return defaultLogo
  }
  return (
    <LogoApp className="p-2">
      {/* <img
        src={IMGlogo}
        alt="logo"
        style={{ width: "100%", maxHeight: "40px", objectFit: "contain" }}
      /> */}
      <a href={getHomepageUrl()}>
        <img src={getLogoApp()} alt={HCF.getCF("appName")} />
      </a>
    </LogoApp>
  )
}

export default connector(SideNavHeader)
